export interface Plan {
  id: string;
  name: string;
}

export const INTEGRAL_HEALTH_PLANS: Plan[] = [
  {id: '018ed73d-6bd2-46e9-8e95-acfc0134435b', name: 'Paciente Salud Integral'},
  {id: '7464fdd5-ec20-407a-984a-b03b015ec191', name: 'Paciente Santander'}
];
